// polyfils
import smoothscroll from 'smoothscroll-polyfill';
import './polyfills/customEvent.js';
import './polyfills/closest.js';
import './polyfills/raf.js';
import './polyfills/object-assign.js';

// Helpers
import './helpers/listener';
import './helpers/eventDelegation';
import './helpers/qsa-array';
import './helpers/index';
import './polyfills/object-fit.js';

// Tools
import ps from 'pubsub-js';

// Libs
// import './modules/';
import './modules/toggle';
import './modules/select';
import './modules/misc';

smoothscroll.polyfill();

// Trigger app start custom event
ps.publish( 'app.start' );

